import { render } from "./Input.vue?vue&type=template&id=5819a8b9"
import script from "./Input.vue?vue&type=script&lang=ts"
export * from "./Input.vue?vue&type=script&lang=ts"
script.render = render

export default script